import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CreditCard, Loader2, CheckCircle2 } from 'lucide-react';
import { api } from '../../context/AuthContext';

// Portal: Karte oder IBAN für einen laufenden Ratenplan selbst austauschen (Stripe-Setup, es wird nichts abgebucht)
export const ZahlartWechseln = ({ plan }) => {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const start = async () => {
    setBusy(true); setErr('');
    try { const r = await api.post(`/raten/${plan.plan_id}/zahlart-wechseln`); window.location.href = r.data.url; }
    catch (e) { setErr(e?.response?.data?.detail || 'Zahlungsart konnte nicht geändert werden'); setBusy(false); }
  };
  return (
    <span className="inline-flex flex-wrap items-center gap-2">
      <button type="button" onClick={start} disabled={busy} className="text-xs px-3 py-2 rounded-[10px] border border-[#b8893d] text-[#1B3A5C] hover:bg-[#fbf7f0] inline-flex items-center gap-1.5 disabled:opacity-50" data-testid={`zahlart-wechseln-${plan.plan_id}`}>
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <CreditCard className="w-3.5 h-3.5" />}Karte oder IBAN ändern
      </button>
      {err && <span className="text-xs text-rose-700" data-testid={`zahlart-fehler-${plan.plan_id}`}>{err}</span>}
    </span>
  );
};

// Rückkehr von Stripe (?zahlart=<plan>&session_id=…): neue Zahlungsart übernehmen und Ergebnis anzeigen
export const ZahlartRueckkehr = ({ onFertig }) => {
  const [sp, setSp] = useSearchParams();
  const [z, setZ] = useState(null);
  const lief = useRef(false);
  const plan = sp.get('zahlart');
  const sid = sp.get('session_id');
  useEffect(() => {
    if (!plan || !sid || lief.current) return;
    lief.current = true;
    api.post(`/raten/${plan}/zahlart-bestaetigen`, { session_id: sid })
      .then((r) => setZ(r.data.ok === false ? { ok: false, text: 'Diese Änderung wurde bereits verarbeitet oder ist abgelaufen. Bitte prüfen Sie Ihre Zahlungsart oder starten Sie die Änderung erneut.' } : { ok: true, text: r.data.fehlgeschlagen ? 'Neue Zahlungsart gespeichert. Offene, nicht eingezogene Raten zieht die Kanzlei damit erneut ein.' : 'Neue Zahlungsart gespeichert – die nächsten Raten werden darüber eingezogen.' }))
      .catch((e) => setZ({ ok: false, text: e?.response?.data?.detail || 'Die neue Zahlungsart konnte nicht übernommen werden.' }))
      .finally(() => { setSp({}, { replace: true }); onFertig?.(); });
  }, [plan, sid]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!z && !(plan && sid)) return null;
  return (
    <div className={`mb-4 flex items-start gap-2 p-3 rounded-xl text-sm ${!z ? 'bg-[#f5f8fa] text-[#34536b]' : z.ok ? 'bg-emerald-50 text-emerald-800' : 'bg-rose-50 text-rose-800'}`} data-testid="zahlart-rueckkehr">
      {!z ? <Loader2 className="w-4 h-4 animate-spin mt-0.5" /> : <CheckCircle2 className="w-4 h-4 mt-0.5" />}<span>{z ? z.text : 'Neue Zahlungsart wird übernommen …'}</span>
    </div>
  );
};

export default ZahlartWechseln;
